import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { Route } from 'react-router-dom';
import App from './App';
import * as store from './store';
import * as serviceWorker from './serviceWorker';
import './index.scss';

const appStore = store.configMyStore(store.initialState);

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Provider store={ appStore }>
        <Route path="/" component={ App } />
      </Provider>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
